module.exports = __webpack_public_path__ + "assets/img/pigeon-idle.55d1bfc7.png";